const KEY = "mailstorm.snooze.v1";

export type SnoozeMap = Record<string, number>;

export function loadSnoozed(): SnoozeMap {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as SnoozeMap;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function saveSnoozed(map: SnoozeMap) {
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* ignore quota */
  }
}

export function pruneSnoozed(map: SnoozeMap): SnoozeMap {
  const now = Date.now();
  const next: SnoozeMap = {};
  for (const [k, wakeAt] of Object.entries(map)) {
    if (wakeAt > now) next[k] = wakeAt;
  }
  return next;
}

export function isSnoozed(key: string, map: SnoozeMap): boolean {
  const wakeAt = map[key];
  return typeof wakeAt === "number" && wakeAt > Date.now();
}

export type SnoozePreset = { id: string; label: string; wakeAt: number };

export function snoozePresets(): SnoozePreset[] {
  const now = Date.now();
  const tonight = new Date();
  tonight.setHours(20, 0, 0, 0);
  if (tonight.getTime() <= now) tonight.setDate(tonight.getDate() + 1);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(9, 0, 0, 0);

  const nextWeek = new Date();
  nextWeek.setDate(nextWeek.getDate() + 7);
  nextWeek.setHours(9, 0, 0, 0);

  return [
    { id: "1h", label: "Tra 1 ora", wakeAt: now + 60 * 60 * 1000 },
    { id: "tonight", label: "Stasera", wakeAt: tonight.getTime() },
    { id: "tomorrow", label: "Domani", wakeAt: tomorrow.getTime() },
    { id: "week", label: "Prossima settimana", wakeAt: nextWeek.getTime() },
  ];
}

export function formatSnoozeUntil(wakeAt: number) {
  return new Date(wakeAt).toLocaleString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
